const TableBody = ({ children, ...props }) => (
    <tbody {...props}>{children}</tbody>
);

export default TableBody;
